import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";

/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import { waitUntil, modalCloses } from 'wfui-digital-core/es/lib';
import { getStore } from '../store/store';
import { showConfirmation } from '../store/navigation/actions';
export default (function (navigation) {
  var _navigation$navigatio = navigation.navigationItem,
      navigationItem = _navigation$navigatio === void 0 ? {} : _navigation$navigatio; // Confirmation is not required for Foresee because it opens in
  // a different window

  if ('foresee' === navigationItem.displayType) {
    return Promise.resolve(navigation);
  }

  navigation.confirmationDeclined = false;
  return new Promise(function (resolve, reject) {
    if (navigation.confirmationRequired) {
      new Promise(function (confirmResolve, confirmReject) {
        getStore().dispatch(showConfirmation({
          confirmationType: 'application',
          confirmResolve: confirmResolve,
          confirmReject: confirmReject
        }));
      }).then(function () {
        return waitUntil(modalCloses, 100, 10, 100).then(function () {
          return resolve(navigation);
        });
      }, function () {
        navigation.confirmationDeclined = true;
        navigation.failureReason = 'Confirmation declined';
        reject(navigation);
      });
    } else {
      resolve(navigation);
    }
  });
});